export const ScannedEditingSetting = {
  "Title": "Scanned Document Editing Settings",
  "Cancel": "Cancel",
  "Ok": "OK",
  "Recognize": "Recognize Text in:",
  "CurrentLanguage": "Current language(s) used for recognizing text:",
  "UseSystem": "Use Available System Font",
  "MakeAllPages": "Make All the Pages Editable",
  "Tip": "Check this option to use a font available in your system when converting images to text. Otherwise, a synthesized font will be used.",
  "TipAllPage": "Check this option to convert all pages of a scanned document to editable text and images in one go."
}